import { Link } from "react-router-dom";
import logoImg from "@/assets/logo.png";

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-canvas border-t border-ink/8 px-8 md:px-12 py-12">
      <div className="max-w-[960px] mx-auto">
        {/* Top row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-10">
          <div>
            <Link to="/" onClick={scrollToTop} className="flex items-center mb-2">
              <img
                src={logoImg}
                alt="REALV3"
                width={400}
                height={170}
                loading="lazy"
                decoding="async"
                className="h-12 md:h-14 w-auto"
              />
            </Link>
            <p className="text-xs text-ink-soft tracking-wide accent-italic">Real estate. Finally yours.</p>
          </div>

          <div className="flex flex-wrap gap-x-7 gap-y-3 items-center">
            <Link to="/about" onClick={scrollToTop} className="text-xs font-medium tracking-wide text-ink-soft hover:text-gold-deep transition-colors duration-400">How it works</Link>
            <Link to="/listings" onClick={scrollToTop} className="text-xs font-medium tracking-wide text-ink-soft hover:text-gold-deep transition-colors duration-400">Search listings</Link>
            <Link to="/list-property" onClick={scrollToTop} className="text-xs font-medium tracking-wide text-ink-soft hover:text-gold-deep transition-colors duration-400">List your home</Link>
            <Link to="/professionals" onClick={scrollToTop} className="text-xs font-medium tracking-wide text-ink-soft hover:text-gold-deep transition-colors duration-400">Professionals</Link>
            <Link to="/contact" onClick={scrollToTop} className="text-xs font-medium tracking-wide text-ink-soft hover:text-gold-deep transition-colors duration-400">Contact</Link>
          </div>
        </div>

        {/* Hairline divider */}
        <div className="divider-hair mb-5" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <span className="text-[11px] tracking-wide text-ink-soft/80">© 2025 REALV3 · All rights reserved</span>
          <div className="flex gap-5">
            <Link to="/privacy" onClick={scrollToTop} className="text-[11px] tracking-wide text-ink-soft/80 hover:text-gold-deep transition-colors duration-400">Privacy</Link>
            <Link to="/privacy" onClick={scrollToTop} className="text-[11px] tracking-wide text-ink-soft/80 hover:text-gold-deep transition-colors duration-400">Terms</Link>
            <Link to="/contact" onClick={scrollToTop} className="text-[11px] tracking-wide text-ink-soft/80 hover:text-gold-deep transition-colors duration-400">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
